import permission from "./permission";

const install = function (Vue) {
  Vue.directive("hp", permission);
};

if (window.Vue) {
  window["hp"] = permission;
  Vue.use(install) // eslint-disable-line
}

permission.install = install;
export default permission;
